import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import {mixins} from "../../mixins";
import {rgba} from "polished";
import Button from "../common/Button";
import CartPage from "../cart/CartPage";
import DeliveryPage from "../cart/DeliveryPage";
import SummaryPage from "../cart/SummaryPage";
import Main from "../layout/Main";
import Nav from "../layout/Nav";
import ScrollToTopOnMount from "../common/ScrollToTopOnMount";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Body = styled.div`
  flex-grow: 1;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const Navigation = styled.div`
  background-color: ${p => p.theme.cBg};
  padding: 26px 30px;
  .container{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const NavigationWing = styled.div`
  
`;

const Content = styled.div`
  padding: 15px 30px;
  flex-grow: 1;
`;

const StepsContainer = styled.div`
  display: flex;
`;

const Step = styled.button`
  display: flex;
  align-items: center;
  padding-right: 56px;
  position: relative;
  color: ${p => rgba(p.theme.cText, 0.35)};
  ${mixins.ease()};
  cursor: pointer;
  border: none;
  background: none;
  outline: none !important;
  &:after{
    ${mixins.pseudoToBlock()};
    position: absolute;
    right: 10px;
    top: 50%;
    height: 1px;
    width: 36px;
    background-color: ${p => rgba(p.theme.cText, 0.35)};
  }
  .stepNumber{
    height: 28px;
    width: 28px;
    margin-right: 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.theme.cWhite};
    font-weight: bold;
    background-color: ${p => rgba(p.theme.cText, 0.35)};
    ${mixins.ease()};
  }
  span{
    display: block;
  }
  &:last-child{
    padding-right: 0;
    &:after{
      display: none;
    }
  }
  &:hover, &:focus{
    color: ${p => rgba(p.theme.cText, 1)};
    text-decoration: none;
  }
  &.step-active{
    color: ${p => rgba(p.theme.cText, 1)};
    .stepNumber{
      background-color: ${p => p.theme.cTheme};
    }
    &:hover, &:focus{
      .stepNumber{
        background-color: ${p => p.theme.cThemeActive};
      }
    }
  }
  &[disabled], &:disabled{
    cursor: not-allowed;
    color: ${p => rgba(p.theme.cText, 0.35)} !important;
  }
`;

class Cart extends Component {

    componentWillMount() {
        this.props.requestProducts();
    }

    getNavigation = () => {
        switch (this.props.page) {
            case 'cart' : {
                return (
                    <div className="container">
                        <NavigationWing>
                            <Button to={'/catalog'} type={'icon'} icon={'arrow-left'} label={'К каталогу'}/>
                        </NavigationWing>
                        <NavigationWing>
                            <Button onClick={() => this.props.cartChangePage({page: 'delivery'})} label={'К доставке'}/>
                        </NavigationWing>
                    </div>
                )
            }
            case 'delivery' : {
                return (
                    <div className="container">
                        <NavigationWing>
                            <Button onClick={() => this.props.cartChangePage({page: 'cart'})} type={'icon'}
                                    icon={'arrow-left'} label={'К корзине'}/>
                        </NavigationWing>
                        <NavigationWing>
                            <Button disabled={this.checkDeliveryWrong()} onClick={() => this.props.cartChangePage({page: 'summary'})} label={'Оформить'}/>
                        </NavigationWing>
                    </div>
                )
            }
            case 'summary' : {
                return (
                    <div className="container">
                        <NavigationWing>
                            <Button onClick={() => this.props.cartChangePage({page: 'delivery'})} type={'icon'}
                                    icon={'arrow-left'} label={'К доставке'}/>
                        </NavigationWing>
                        <NavigationWing>
                            <Button label={'Оплатить'}/>
                        </NavigationWing>
                    </div>
                )
            }
            default :
                return '';
        }
    };

    checkDeliveryWrong = () => {
        const form = this.props.delivery_info;
        let wrong = false;
        if (!form.name) wrong = true;
        if (!form.phone) wrong = true;
        if (!validateEmail(form.email)) wrong = true;
        if (!form.agreed) wrong = true;
        if (form.delivery !== 'self'){
            if (!form.address) wrong = true;
            if (!form.city) wrong = true;
            if (!form.postcode) wrong = true;
        }
        return wrong;
    };

    render() {
        //console.log(this.checkDeliveryWrong());
        return (
            <React.Fragment>
                <ScrollToTopOnMount/>
                <Nav folded={true}/>
                <Main>
                    <Container>
                        <Navigation>
                            <div className="container">
                                <NavigationWing>
                                    В вашей корзине <strong>{this.props.items.length}</strong> продуктов
                                </NavigationWing>
                                <NavigationWing>
                                    <StepsContainer>
                                        <Step className={this.props.page === 'cart' ? 'step-active' : ''}
                                              onClick={() => this.props.cartChangePage({page: 'cart'})}>
                                            <div className='stepNumber'>1</div>
                                            <span>Корзина</span>
                                        </Step>
                                        <Step className={this.props.page === 'delivery' ? 'step-active' : ''}
                                              onClick={() => this.props.cartChangePage({page: 'delivery'})}>
                                            <div className='stepNumber'>2</div>
                                            <span>Доставка</span>
                                        </Step>
                                        <Step className={this.props.page === 'summary' ? 'step-active' : ''}
                                              onClick={() => this.props.cartChangePage({page: 'summary'})}
                                              disabled={this.checkDeliveryWrong()} >
                                            <div className='stepNumber'>3</div>
                                            <span>Оплата</span>
                                        </Step>
                                    </StepsContainer>
                                </NavigationWing>
                            </div>
                        </Navigation>
                        <Body>
                        <div className="container">
                            {this.props.page === 'cart' ? <CartPage/> : ''}
                            {this.props.page === 'delivery' ? <DeliveryPage/> : ''}
                            {this.props.page === 'summary' ? <SummaryPage/> : ''}
                        </div>
                        </Body>
                        <Navigation>
                            {this.getNavigation()}
                        </Navigation>
                    </Container>
                </Main>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        items: state.getIn(['cart', 'items']),
        page: state.getIn(['cart', 'page']),
        delivery_info: state.getIn(['cart', 'delivery_info']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        cartChangePage: Actions.cartChangePage,
        requestProducts: Actions.requestProducts
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(Cart)`
`));

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}